import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://wlbbezquaiyxxwmctxno.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndsYmJlenF1YWl5eHh3bWN0eG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI5MjY2NzcsImV4cCI6MjA3ODUwMjY3N30.zwcwoE3zrrZnskwalrlEoX8XKzLnNxE-MvanwQRvB3M'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Import the supabase client like this:
// For React:
// import { supabase } from "@/integrations/supabase/client";
// For React Native:
// import { supabase } from "@/src/integrations/supabase/client";
